import React from "react";
import cx from "classnames";
import styles from "./Header.module.scss";
import { Logo } from "../Logo/Logo";
import { ReactComponent as ArrowRight } from "../ArrowRight.svg";
import { ReactComponent as ArrowLeft } from "../ArrowLeft.svg";

export const Header: React.FunctionComponent = () => {
  return (
    <header className={cx(styles.header)}>
      <div className={styles.logo}>
        <Logo />
      </div>
      <ul className={styles.links}>
        <li>
          <a className={styles.headerLink} href="#players">
            <ArrowLeft />
            Players
            <ArrowRight />
          </a>
        </li>
        <li>
          <a className={styles.headerLink} href="#transfers">
            <ArrowLeft />
            Transfers
            <ArrowRight />
          </a>
        </li>
        <li>
          <a className={styles.headerLink} href="#about">
            <ArrowLeft />
            About
            <ArrowRight />
          </a>
        </li>
        <li>
          <a className={styles.headerLink} href="#contact">
            <ArrowLeft />
            Contact
            <ArrowRight />
          </a>
        </li>
      </ul>
    </header>
  );
};
